export default __webpack_public_path__ + "static/media/logout-icon.1683960b.svg";